(() => {
  if (window.customRecommendationHoverImageV1) return;
  window.customRecommendationHoverImageV1 = true;
  const desktop = matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)');
  const selector = '.custom-compact-recommendations-v1 [data-custom-recommendation-hover-src]';
  document.addEventListener('pointerover', (event) => {
    if (!desktop.matches || event.pointerType === 'touch') return;
    const card = event.target.closest(selector);
    if (!card || card.contains(event.relatedTarget)) return;
    card.dataset.customRecommendationHovered = 'true';
    if (card.dataset.customRecommendationHoverLoaded === 'true') {
      card.classList.add('custom-recommendation-hover-visible');
      return;
    }
    if (card.dataset.customRecommendationHoverLoading) return;
    const media = card.querySelector('.card__media .media');
    if (!media) return;
    card.dataset.customRecommendationHoverLoading = 'true';
    const image = new Image();
    image.className = 'custom-recommendation-hover-image motion-reduce';
    image.alt = card.dataset.customRecommendationHoverAlt || '';
    image.sizes = '(min-width: 750px) 176px, calc((100vw - 55px) / 2)';
    image.onload = async () => {
      try { await image.decode(); } catch { /* Loaded image remains usable. */ }
      delete card.dataset.customRecommendationHoverLoading;
      if (!card.isConnected) return;
      media.append(image);
      card.dataset.customRecommendationHoverLoaded = 'true';
      if (desktop.matches && card.dataset.customRecommendationHovered === 'true') card.classList.add('custom-recommendation-hover-visible');
    };
    image.onerror = () => { delete card.dataset.customRecommendationHoverLoading; };
    // No secondary image URLs enter src/srcset until an actual desktop hover.
    image.srcset = card.dataset.customRecommendationHoverSrcset;
    image.src = card.dataset.customRecommendationHoverSrc;
  });
  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest(selector);
    if (!card || card.contains(event.relatedTarget)) return;
    delete card.dataset.customRecommendationHovered;
    card.classList.remove('custom-recommendation-hover-visible');
  });
  desktop.addEventListener('change', () => {
    if (desktop.matches) return;
    document.querySelectorAll(selector).forEach((card) => {
      delete card.dataset.customRecommendationHovered;
      card.classList.remove('custom-recommendation-hover-visible');
    });
  });
})();
